import { DEFAULT_AGE } from 'constants/values';
import { ActivityLevels, FitnessLevel } from 'constants/onboardingFlow';

import { OnboardingStore } from 'types/onboarding/onboardingStore';

import dayjs from 'dayjs';

export const SKIP_ONBOARDING_STATE: OnboardingStore = {
    gender: 'female',
    goal: ['lose_weight'],
    current_body: 'regular',
    target_bodytype: 'shapely',
    target_zone: ['belly', 'chest', 'arms'],
    target_weight: 55,
    activityLevel: ActivityLevels.HIGHLY_ACTIVE,
    yogaLevel: 'intermediate',
    age: DEFAULT_AGE,
    tall: 167,
    current_weight: 65,
    measureSystem: 'METRIC',
    onboardingScreensList: {},
    urlParams: null,
    occasion: 'reunion',
    occasion_date: dayjs().add(3, 'months'),
    fitnessLevel: FitnessLevel.Experienced,
    age_range: {},
    current_mood: 'angry',
    stress_factors: ['work', 'health_issues', 'relationships'],
    sleep_problems: ['tossing_turning', 'waking_night'],
    occasionResultConfig: {
        targetDate: dayjs().add(4, 'months'),
        weightList: [86, 83, 80, 77],
        monthsArray: ['Jan', 'Feb', 'Mar', 'Apr'],
    },
    focus: ['fat_burn'],
    body_image: '1_2_years_ago',
    reason: 'being_stronger',
    reward: 'buying_new_clothes',
    // todo: add configPaymentParams to skip onboarding
    goalGeneral: 'lose_weight',
};
